import React from 'react';
import { makeStyles, CircularProgress as MuiCircularProgress } from '@material-ui/core';

const CircularProgress = () => {
  const classes = useProgressBarStyles();
  return <MuiCircularProgress className={classes.progressBar} size={40} />;
};
const useProgressBarStyles = makeStyles({
  progressBar: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-20px',
    marginLeft: '-20px'
  }
});

export default CircularProgress;
